<div class="module-container-full-width category-view-container">
  <gb-back-button [label]="'CATEGORIES.BACK_BUTTON'" (click)="backToCategories()"> </gb-back-button>
  <ng-container
    *ngIf="{
      category: selectedCategory$ | async,
      items: filteredItems$ | async
    } as obs"
  >
    <div *ngIf="obs.category" id="category-view">
      <div class="category-heading-container flex-row flex-justify-start flex-align-center px-gap-10">
        <div class="flex-col">
          <h2 class="category-title">
            {{ obs.category.label }}
          </h2>
        </div>
        <div class="flex-col">
          <span
            [translate]="getItemsText(obs.category.items_count)"
            [translateParams]="{ number: obs.category.items_count }"
            class="item-count"
          >
          </span>
        </div>
      </div>
      <gb-items-observer
        [stalePages$]="staleFilteredPages$"
        (onFocusEvent)="onFocus($event)"
        (onScrollEvent)="onScroll($event)"
      >
        <gb-item-list
          [items$]="filteredItems$"
          [categoryId]="categoryId"
          [isLoading]="isLoading$ | async"
          (onElementsReady)="setItemsToObserve($event)"
          (scrolled)="onEndReached(obs.items, obs.category.items_count)"
        >
        </gb-item-list>
      </gb-items-observer>
    </div>

    <ng-container
      *ngIf="(isLoading$ | async) && (isMoreItemsToLoad(obs.items, obs.category?.items_count) || !obs.category)"
    >
      <div class="loader-container flex-row flex-justify-center flex-align-center">
        <gb-loading-spinner [showLoader]="isLoading$" [label]="'LOADING_ITEMS'"> </gb-loading-spinner>
      </div>
    </ng-container>
  </ng-container>
</div>
